import { Modal } from '@iwoca/orion';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import StepItem from '../stepItem/StepItem';
import messages from './ApplicantCallAction.messages';
import ApplicantCallModal from './ApplicantCallModal';
import { FormalOffer } from '../../../myOffers/MyOffers.types';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';

export const ApplicantCallAction = ({
    productType,
    status
}: {
    productType: FormalOffer['product_type'];
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(!isModalOpen);
    };

    const isIwocaPay: boolean = productType === 'iwocapay';
    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    <FundingStepActionButton
                        actionMessage={
                            <FormattedMessage {...messages.action} />
                        }
                        pendingMessage={
                            <FormattedMessage {...messages.pending} />
                        }
                        status={status === 'PENDING' ? 'REQUIRED' : status}
                        handleFundingStepAction={() => setIsModalOpen(true)}
                    />
                }
            />

            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <ApplicantCallModal
                    onClose={handleModalClose}
                    isIwocaPay={isIwocaPay}
                />
            </Modal>
        </>
    );
};
